const isLoading = state => state.isLoading.isLoading;

export default { isLoading };
